import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import SecondaryResourcesCategoryView from "./SecondaryResourcesCategoryView"
import Secondary1TB from "../images/secondary-1.jpg"
import ZipLogo from "../images/zip.svg"

class Secondary1Resources extends React.Component {
  state = {
    view: {
      title: "Secondary 1 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Secondary1TB,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G10-Secondary-1-TB_WM_2022.pdf",
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/audio-april-2022/",
          files: [{ name: "Secondary 1 Audio", file: "Secondary-1-audio.zip" }],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <SecondaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Secondary1Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesSecondary1.js